import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-1 d-flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-4 card-title" }, "Price estimate", -1)
const _hoisted_4 = { class: "fw-bolder fs-3 text-info d-flex align-items-center" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "flex-grow-1 me-2" }
const _hoisted_7 = { class: "fw-bolder text-gray-800 fs-6" }
const _hoisted_8 = { class: "text-info fw-bolder py-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.total)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, " Total : " + _toDisplayString(_ctx.total) + " " + _toDisplayString(_ctx.currency && _ctx.total ? _ctx.currency.code : ""), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estimates, (estimate) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "bg-light-info d-flex align-items-center rounded p-5 mb-3",
              style: {"height":"50px"},
              key: estimate.id
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(estimate.name), 1)
              ]),
              _createElementVNode("span", _hoisted_8, _toDisplayString(estimate.cost.toFixed(2)) + " " + _toDisplayString(_ctx.currency ? _ctx.currency.code : ""), 1)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}